// Point d'entrée esbuild du PORTAIL CLIENT (sortie app/assets/builds/client_vendor.js).
//
// Il ne contient que Bootstrap 5, en remplacement du <script> CDN jsdelivr que
// chargeait layouts/client/_head.html.erb (phase 8, vague 2). Le portail s'appuie
// entièrement sur l'auto-initialisation par attributs data-bs-* — modale de fiche
// campus, onglets « pills » de la fiche, dropdown du compte dans l'en-tête — donc
// il suffit que le module soit ÉVALUÉ : son écouteur délégué global sur `document`
// fait le reste, sans une ligne de code applicatif.
//
// Pourquoi un entrypoint dédié plutôt que vendor.js ? Parce que vendor.js, c'est
// aussi jQuery, jQuery UI (autocomplete, sortable, datepicker), cocoon et
// Chartkick/Chart.js : environ 300 ko dont le portail n'a strictement aucun usage.
// Aucune vue client, aucun contrôleur Stimulus du portail ne touche à $.
//
// window.bootstrap est exposé par symétrie avec vendor.js : le jour où un
// contrôleur Stimulus du portail devra piloter la modale à la main
// (`bootstrap.Modal.getOrCreateInstance`), il le trouvera là où le back-office le
// trouve déjà. Le CDN posait ce même global.
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
